export default "__VITE_ASSET__CzPWyNro__"